import { all, AllEffect } from '@redux-saga/core/effects';
import { call, Effect } from 'redux-saga/effects';

import watchPostSendMailSaga from './postSendMailSaga';
import watchPutMailAddressSaga from './putMailAddressSaga';

export default function* mailSaga(): Generator<AllEffect<Effect>, void, unknown> {
  yield all([call(watchPostSendMailSaga), call(watchPutMailAddressSaga)]);
}
